namespace AgerLMS.LMS {
    export interface LmsSectionRow {
        SectionId?: number;
        SectionName?: string;
        SectionDescription?: string;
        CourseId?: number;
        DisplayOrder?: number;
        CourseCourseName?: string;
        CourseCourseDescription?: string;
        CourseCategoryId?: number;
        CoursePrice?: number;
        CourseSalePrice?: number;
        SectionContentCount?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        IsActive?: number;
        InsertUserDisplayName?: string;
    }

    export namespace LmsSectionRow {
        export const idProperty = 'SectionId';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'SectionName';
        export const localTextPrefix = 'LMS.LmsSection';
        export const lookupKey = 'LMS.Section';

        export function getLookup(): Q.Lookup<LmsSectionRow> {
            return Q.getLookup<LmsSectionRow>('LMS.Section');
        }
        export const deletePermission = 'LMS';
        export const insertPermission = 'LMS';
        export const readPermission = 'LMS';
        export const updatePermission = 'LMS';

        export declare const enum Fields {
            SectionId = "SectionId",
            SectionName = "SectionName",
            SectionDescription = "SectionDescription",
            CourseId = "CourseId",
            DisplayOrder = "DisplayOrder",
            CourseCourseName = "CourseCourseName",
            CourseCourseDescription = "CourseCourseDescription",
            CourseCategoryId = "CourseCategoryId",
            CoursePrice = "CoursePrice",
            CourseSalePrice = "CourseSalePrice",
            SectionContentCount = "SectionContentCount",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            IsActive = "IsActive",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
